// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"2e5045d6","288":"6d97b5f7","396":"b7c70f97","453":"5fb60e76","741":"275fe622"}[chunkId] + ".chunk.js";
};